// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

import '@hotwired/turbo-rails';
import '@github/clipboard-copy-element';
import 'trix';
import '@rails/actiontext';
import './controllers';
import '../components/cloudflare/turnstile_component_controller';
import './tippy-it';

document.addEventListener('turbo:before-morph-attribute', (event) => {
  const { target } = event;

  if (target.tagName === 'TRIX-EDITOR' || target.tagName === 'TRIX-TOOLBAR') {
    event.preventDefault();
  }
});

document.addEventListener('turbo:before-morph-element', (event) => {
  const { target } = event;

  if (target.tagName === 'TRIX-EDITOR' || target.tagName === 'TRIX-TOOLBAR') {
    event.preventDefault();
  }
});
